import { LayoutGrid, Calendar, ListTodo, StickyNote, LogOut, Plus, Settings } from 'lucide-react';
import { useAuthStore } from '../store/authStore';

interface SidebarProps {
  currentView: string;
  onNavigate: (view: string) => void;
  onNewWorksheet?: () => void;
}

const navItems = [
  { id: 'projects', label: 'Arbeitsblätter', icon: LayoutGrid, mobileHidden: false },
  { id: 'calendar', label: 'Kalender',       icon: Calendar,   mobileHidden: false },
  { id: 'todos',    label: 'Todo-Liste',     icon: ListTodo,   mobileHidden: false },
  { id: 'notes',    label: 'Notizen',        icon: StickyNote, mobileHidden: false },
];

export default function Sidebar({ currentView, onNavigate, onNewWorksheet }: SidebarProps) {
  const { user, logout } = useAuthStore();

  return (
    <aside className="sl-sidebar">
      {/* Logo */}
      <div className="px-5 pb-4">
        <img src="/brand/wordmark.svg" alt="SketchLessons" className="h-7" />
      </div>

      <div className="sl-divider mx-4" />

      {/* New Worksheet Button */}
      {onNewWorksheet && (
        <div className="px-4 py-3">
          <button
            onClick={onNewWorksheet}
            className="sl-button sl-button-primary w-full gap-2 !justify-center"
          >
            <Plus className="w-4 h-4" />
            Neues Arbeitsblatt
          </button>
        </div>
      )}

      {/* Navigation */}
      <nav className="flex-1 px-2 pt-2 space-y-1">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = currentView === item.id;
          return (
            <button
              key={item.id}
              onClick={() => onNavigate(item.id)}
              className={`sl-sidebar-item w-full text-left ${isActive ? 'active' : ''} ${item.mobileHidden ? 'hidden md:flex' : ''}`}
            >
              <Icon className="w-[18px] h-[18px]" strokeWidth={isActive ? 2.5 : 2} />
              <span>{item.label}</span>
            </button>
          );
        })}
      </nav>

      <div className="sl-divider mx-4" />

      {/* Bottom */}
      <div className="px-4 pt-2 space-y-1">
        <button
          onClick={() => onNavigate('settings')}
          className={`sl-sidebar-item w-full text-left ${currentView === 'settings' ? 'active' : ''}`}
        >
          <Settings className="w-[18px] h-[18px]" strokeWidth={currentView === 'settings' ? 2.5 : 2} />
          <span>Einstellungen</span>
        </button>
        <button
          onClick={logout}
          className="sl-sidebar-item w-full text-left text-coral hover:text-coral-deep hover:bg-coral-soft"
        >
          <LogOut className="w-[18px] h-[18px]" strokeWidth={2} />
          <span>Abmelden</span>
        </button>
      </div>

      {/* User */}
      {user && (
        <div className="px-5 pt-4 pb-2">
          <div className="flex items-center gap-3 px-3 py-2.5 rounded-xl bg-paper-deep">
            <div className="w-8 h-8 rounded-full bg-cobalt-soft flex items-center justify-center text-cobalt text-sm font-bold">
              {user.name?.charAt(0)?.toUpperCase() || '?'}
            </div>
            <div className="overflow-hidden">
              <p className="text-sm font-semibold text-ink truncate">{user.name}</p>
              <p className="text-xs text-ink-mute truncate">{user.email}</p>
            </div>
          </div>
        </div>
      )}
    </aside>
  );
}
